import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';

let APIInstance: AxiosInstance | null = null;


// Lazy load config.json once
const initAPI = async () => {
    if (APIInstance) return APIInstance;

    let config = { REACT_APP_API_BASE_URL: '' };

    try {
        const response = await fetch('/config.json');
        config = await response.json();
    } catch (e) {
        console.error('Failed to load config.json:', e);
    }

    APIInstance = axios.create({
        baseURL: config.REACT_APP_API_BASE_URL || 'http://localhost:5196',
        withCredentials: true,
        headers: { 'Content-Type': 'application/json' }
    });

    APIInstance.interceptors.request.use(
        (config) => {
            const storedUser = localStorage.getItem('user');
            if (storedUser) {
                try {
                    const parsed = JSON.parse(storedUser);
                    const user = parsed?.user || parsed;
                    config.headers['authToken'] = user?.authtoken || '';
                    config.headers['sessionId'] = user?.sessionId || '';
                } catch (e) {
                    console.warn('Failed to parse user from localStorage');
                }
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    APIInstance.interceptors.response.use(
        response => response,
        error => {
            if (error.response?.status === 401) {
                localStorage.removeItem('user');
                window.location.href = '/login';
            }
            return Promise.reject(error);
        }
    );

    return APIInstance;
};

// This exports a Promise-compatible object that resolves to the axios instance
const API: any = new Proxy({}, {
    get: function (_, prop) {
        return async (...args: any[]) => {
            const instance = await initAPI();
            const fn = (instance as any)[prop];
            return typeof fn === 'function' ? fn.apply(instance, args) : fn;
        };
    }
});

export default API;
